// export const basciUrl = 'https://www.tksaasapi.com'
export const basciUrl = 'https://asdm.saskiwin.com'
// export const basciUrl = ''